import { render, staticRenderFns } from "./guanqiaLostData2.vue?vue&type=template&id=fe814eb4&"
import script from "./guanqiaLostData2.vue?vue&type=script&lang=js&"
export * from "./guanqiaLostData2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/www/game/xcp-vue-xcll/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fe814eb4')) {
      api.createRecord('fe814eb4', component.options)
    } else {
      api.reload('fe814eb4', component.options)
    }
    module.hot.accept("./guanqiaLostData2.vue?vue&type=template&id=fe814eb4&", function () {
      api.rerender('fe814eb4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/xcpGameData/guanqia/guanqiaLostData2.vue"
export default component.exports